'use client';

import type { PropsWithChildren } from 'react';
import type { GlobalAppStateStoreInstance } from '../../stores/app/GlobalAppStateStore/selectors';
import { ActiveThemeContextProvider } from './ActiveThemeContext';

export function ActiveThemeProvider({
  store,
  children,
}: PropsWithChildren<{ store: GlobalAppStateStoreInstance }>) {
  const activeTheme = store.hooks.useActiveTheme();
  return <ActiveThemeContextProvider value={activeTheme}>{children}</ActiveThemeContextProvider>;
}
